import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/participantes-entregas";

const getParticipantesEntregas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

export {
  getParticipantesEntregas
};